import {
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_ERROR,
  GET_SETTING,
  SET_REF,
  SET_LANG,
} from "../../actions/types";

// Until the settings endpoint was split, `jsonstring` cached the *full* site
// settings document -- SMTP address and password included -- in every visitor's
// localStorage. Those copies survive the server-side fix, so drop any cached
// entry that still carries a secret field instead of rehydrating from it.
const SECRET_SETTING_FIELDS = ["smtpemail", "smtppass", "bccemail"];

const readCachedSetting = () => {
  if (typeof window === "undefined") return null;

  try {
    const cached = JSON.parse(localStorage.getItem("jsonstring"));

    if (cached && SECRET_SETTING_FIELDS.some((field) => field in cached)) {
      localStorage.removeItem("jsonstring");
      return null;
    }

    return cached;
  } catch (error) {
    localStorage.removeItem("jsonstring");
    return null;
  }
};

const initialState = {
  setting: readCachedSetting(),
  loading: true,
  error: {},
  ref: null,
  lang: typeof window !== "undefined" ? localStorage.getItem("lang") : "jp",
};

export default function foo(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_LANG:
      return {
        ...state,
        lang: payload,
        loading: false,
      };
    case UPDATE_SETTINGS:
    case GET_SETTING:
      return {
        ...state,
        setting: payload,
        loading: false,
      };
    case UPDATE_SETTINGS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case SET_REF:
      return {
        ...state,
        ref: payload,
        loading: false,
      };
    default:
      return state;
  }
}
